import { createSlice } from '@reduxjs/toolkit';

const  initialState = {
    currentMeetings: [],
    leaveMeetingData: {
        shouldLeave: false,
        meetingId: null,
        patientId: null,
    },

    appointmentData: {},
    minimized: false,
    showing: false
};
const appointmentSlice = createSlice({
    name: 'appointment',
    initialState,
    reducers: {
        setCurrentMeetings: (state, action) => {
            // Find index of the meeting with the same appointmentId
            const index = state.currentMeetings.findIndex(meeting => meeting.appointmentId === action.payload.appointmentId);
            if (index !== -1) {
                // Replace the old meeting with the new one
                state.currentMeetings[index] = action.payload;
            } else {
                state.currentMeetings.push(action.payload);
            }
        },
        removeMeeting: (state, action) => {
            // Filter out the meeting with the specified appointmentId
            state.currentMeetings = state.currentMeetings.filter(
                meeting => meeting.appointmentId !== action.payload
            );
        },
        leaveMeeting: (state, action) => {
            // Store meetingId and patientId with the leave flag
            state.leaveMeetingData = {
                shouldLeave: true,
                meetingId: action.payload.meetingId,
                patientId: action.payload.patientId
            };
            // Remove the meeting from currentMeetings when patient leaves
            // Match by appointmentId (most reliable), meetingId, or patientId to find the correct meeting
            state.currentMeetings = state.currentMeetings.filter(
                meeting => {
                    // First try to match by appointmentId if available (most reliable)
                    const matchesAppointmentId = action.payload.appointmentId && 
                        meeting.appointmentId === action.payload.appointmentId;
                    // Match by meetingId (check both direct and nested structures)
                    const matchesMeetingId = action.payload.meetingId && 
                        (meeting.meetingId === action.payload.meetingId || 
                         meeting.meeting?.MeetingId === action.payload.meetingId ||
                         (typeof meeting.meetingId === 'string' && meeting.meetingId === String(action.payload.meetingId)) ||
                         (typeof meeting.meeting?.MeetingId === 'string' && meeting.meeting.MeetingId === String(action.payload.meetingId)));
                    // Match by patientId
                    const matchesPatientId = action.payload.patientId && 
                        (meeting.patientId === action.payload.patientId ||
                         meeting.patientId === String(action.payload.patientId) ||
                         String(meeting.patientId) === String(action.payload.patientId));
                    // Keep meetings that don't match (remove matching ones)
                    const shouldRemove = matchesAppointmentId || matchesMeetingId || matchesPatientId;
                    return !shouldRemove;
                }
            );
        },
        resetLeaveMeetingFlag: (state) => {
            state.leaveMeetingData = {
                shouldLeave: false,
                meetingId: null,
                patientId: null
            };
        },
        toggleMinimized: (state) => {
            state.minimized = !state.minimized
        },
        setAppointmentData: (state, action) => {
            state.appointmentData = action.payload;
            state.showing = true;
        },
        closeAppointment: (state) => {
            state.showing = false;
            state.minimized = false;
            state.appointmentData = {};
        }
    },
});

export const { setCurrentMeetings, removeMeeting, leaveMeeting, resetLeaveMeetingFlag, toggleMinimized, setAppointmentData, closeAppointment} = appointmentSlice.actions;

export default appointmentSlice.reducer;
